import { styled } from "@mui/material/styles";

const StyledForgetPassword = styled("div")(
  ({ theme }) => `
  .forgetpass-wrap {
  width: 40%;
  margin: 0 auto;
  padding: 30px 0;

  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
  }
}
.forgetpass-header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: normal;
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }  
}
.forgetpass-sub-header{
  margin-top: 12px;
  margin-bottom: 32px;
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
    @media screen and (max-width: 480px) {
    font-size: 14px;
  }  
}
.forgetpass-textfeilds {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.backLogin {
  text-align: center;
  margin-top: 10px;
}
.backLogin a {
  font-family: Lexend;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.palette.primary.main};
  text-decoration: underline
}    
`
);

export default StyledForgetPassword;
